import {
  mayNudgeShow,
  setModalState
} from '@carvana/merch-nudge-manager/consumer';
import { useCallback, useEffect, useState } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useQualiFactoryUpgradesCriteria } from '~/context/common/FactoryUpgradesQualiContext';
import { QUALI_SRP_HELIOS } from '~/context/srp/QualiContext';
import { QUALI_FACTORY_UPGRADES_NAME } from '~/hooks/common/experiments/useIsInFactoryUpgradesQualiExperiment';
import useQualiModalCore, {
  SurveyConfig
} from '~/hooks/common/quali/useQualiModalCore';
import useHeliosQualiModal from '~/hooks/srp/useHeliosQualiModal';
import sendMessageToNative from '~/native/srp/dispatchers/sendMessageToNative';

const QUALI_MODAL_STATE_ID = 'quali';

function useActiveSurvey(): SurveyConfig | undefined {
  const shouldOpenHeliosSurvey = useHeliosQualiModal();
  const shouldOpenFactoryUpgradesSurvey = useQualiFactoryUpgradesCriteria();
  const [activeSurvey, setActiveSurvey] = useState<SurveyConfig | undefined>();

  useEffect(() => {
    if (activeSurvey) return;

    if (shouldOpenFactoryUpgradesSurvey) {
      setActiveSurvey({
        analyticsTitle: 'Factory Upgrades',
        delay: 5000,
        name: QUALI_FACTORY_UPGRADES_NAME,
        title: 'How do you like our new Factory Upgrades feature?'
      });
    } else if (shouldOpenHeliosSurvey) {
      setActiveSurvey({
        analyticsTitle: 'SRP Helios',
        delay: 2000,
        name: QUALI_SRP_HELIOS,
        title: 'How do you like our updated search experience?'
      });
    }
  }, [activeSurvey, shouldOpenFactoryUpgradesSurvey, shouldOpenHeliosSurvey]);

  return activeSurvey;
}

export default function useQualiModal() {
  const activeSurvey = useActiveSurvey();
  const trackEvent = useTrackEvent();

  const beforeShow = useCallback(async () => {
    const { mayShow } = await mayNudgeShow(QUALI_MODAL_STATE_ID);

    return mayShow;
  }, []);

  const onOpenStateChange = useCallback((isOpen: boolean) => {
    void setModalState(QUALI_MODAL_STATE_ID, isOpen);
  }, []);

  useQualiModalCore({
    activeSurvey,
    beforeShow,
    onOpenStateChange,
    sendMessageToNative,
    trackEvent
  });
}
